import Link from 'next/link';
import classNames from 'classnames';

import { Cart } from '@components/cart/Cart';
import { Svg } from '@components/svg/Svg';

import { useCart } from '@context/CartContext';
import { MEMBERSHIPS_URL } from '@data/constants';

import styles from './navigation-add-on.module.scss';

type NavigationAddOnProps = {
	hideLabelOnDesktop?: boolean;
	overrideDesktopColor?: 'sand' | 'black';
	showCart?: boolean;
};

export const NavigationAddOn = ({
	hideLabelOnDesktop = false,
	showCart = true,
	overrideDesktopColor,
}: NavigationAddOnProps) => {
	const { cart } = useCart();

	const isCartVisible = showCart && cart && cart.totalQuantity > 0;

	return (
		<div
			className={classNames(styles['navigation-addon'], {
				[styles['navigation-addon--hide-label-on-desktop']]: hideLabelOnDesktop,
				[styles[
					`navigation-addon--override-desktop-color-${overrideDesktopColor}`
				]]: overrideDesktopColor,
			})}
		>
			{isCartVisible ? <Cart /> : null}
			<Link
				aria-label="Sign In"
				className={classNames(styles['link-wrapper'], 'navigation-anchor', {
					[styles['link-wrapper--cart-visible']]: isCartVisible,
				})}
				href={MEMBERSHIPS_URL}
			>
				<p className={styles.login}>Memberships</p>
				<Svg
					className={classNames(styles['user-icon'], {
						[styles['user-icon--cart-visible']]: isCartVisible,
					})}
					id="account-icon"
				/>
			</Link>
		</div>
	);
};
